import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { engagementApi, normalizeSearch } from "../Services/engagementService";

// After a search, a signed-in visitor is asked whether to keep it in "Recherches récentes":
// nothing is saved unless they accept. Answering (save or no) hides the question for this search;
// a different search asks again (sorting or paging do not change the search).
export default function SaveSearchPrompt({ search }) {
  const { t } = useTranslation();
  const [handled, setHandled] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(null);
  const [error, setError] = useState("");
  const key = search && engagementApi.canSaveSearch?.() ? JSON.stringify(normalizeSearch(search)) : null;
  if (saved && saved === key) return <p role="status" className="my-3 text-sm font-semibold text-green-800">{t("saveSearch.saved")}</p>;
  if (!key || handled === key) return null;
  const save = async () => {
    setSaving(true); setError("");
    try { await engagementApi.saveSearch(search); setSaved(key); setHandled(key); }
    catch (e) { setError(e?.message || t("saveSearch.error")); }
    finally { setSaving(false); }
  };
  return <section aria-label={t("saveSearch.question")} className="my-3 flex flex-wrap items-center gap-3 rounded-xl border border-green-200 bg-green-50 px-4 py-3 text-sm">
    <span className="font-semibold text-slate-900">{t("saveSearch.question")}</span>
    <button type="button" className="min-h-[40px] rounded-lg bg-green-700 px-4 font-bold text-white disabled:opacity-60" disabled={saving} onClick={save}>{t(saving ? "saveSearch.saving" : "saveSearch.save")}</button>
    <button type="button" className="min-h-[40px] rounded-lg border border-slate-300 px-4 font-semibold text-slate-700" disabled={saving} onClick={() => setHandled(key)}>{t("saveSearch.dismiss")}</button>
    {error && <span role="alert" className="text-red-700">{error}</span>}
  </section>;
}
